import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { CmsContentType, CmsMedia } from '@fcom/core-api';

@Component({
  selector: 'fin-detail-text',
  templateUrl: './detail-text.component.html',
  styleUrls: ['./detail-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DetailTextComponent {
  readonly CmsContentType = CmsContentType;

  mediaObject = input<CmsMedia[]>();
  markup = input('');
}
